import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import { moduleList } from 'Api/courseDetailsDates';

const useFetch = courseId => {
  const [dates, setDates] = useState();
  const [userCount, setUserCount] = useState();

  const { id } = useSelector(userSelector);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      moduleList({ courseId, userId: id }).then(data => {
        setDates(data.lessons);
        setUserCount(data.userCount);
      });
    }

    return () => {
      isMounted = false;
      setDates([]);
      setUserCount([]);
    };
  }, [courseId]);

  return {
    dates,
    userCount,
  };
};

export default useFetch;
